<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="请输入搜索内容"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="add">新增角色</el-button>
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column label="角色名称" align="center" prop="name">
      </el-table-column>
      <el-table-column label="操作员" align="center" prop="operation_name">
      </el-table-column>
      <el-table-column label="权限" align="center">
        <template #default="scope">
          <el-popover
            title="权限"
            width="400px"
            placement="right"
            trigger="click"
            :ref="`popover-${scope.$index}`"
          >
            <div class="role-permission">{{ scope.row.permission_name }}</div>
            <template #reference>
              <div class="permission_name">{{ scope.row.permission_name }}</div>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建日期" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.create_time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" align="center">
        <template #default="scope">
          <el-button type="success" size="mini" @click="edit(scope.row)"
            >编辑角色</el-button
          >
          <el-button type="danger" size="mini" @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 新增操作员 -->
    <el-dialog
      title="新增角色"
      v-model="add_role_dialog"
      width="600px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <div class="administrator">
        <el-form
          :model="form"
          ref="form"
          size="small"
          :rules="rules"
          label-width="110px"
          label-position="top"
        >
          <div>
            <el-form-item label="角色名称：" prop="roleName">
              <el-input
                maxlength="30"
                show-word-limit
                placeholder="角色名称"
                v-model="form.roleName"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="选择权限：" prop="keys">
              <el-scrollbar>
                <el-tree
                  :props="props"
                  node-key="permissionId"
                  :data="permissionList"
                >
                  <template #default="{ node, data }">
                    <label
                      class="el-checkbox"
                      @click.stop="check(data, data.value ? 0 : 1)"
                    >
                      <span
                        class="el-checkbox__input"
                        :class="{ 'is-checked': data.value === 1 }"
                      >
                        <span class="el-checkbox__inner"></span>
                      </span>
                    </label>
                    <span>{{ node.label }}</span>
                  </template>
                </el-tree>
              </el-scrollbar>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" size="small" @click="save">确定</el-button>
          <el-button type="danger" size="small" @click="add_role_dialog = false"
            >取消</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      add_role_dialog: false,
      role_dialog: false,
      itemData: {},
      isManagerData: [],
      commonUser: [],
      form: {
        roleName: "",
        keys: [],
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        keys: [
          {
            required: true,
            validator: (rule, value, callback) => {
              this.checkKeys(rule, value, callback);
            },
            trigger: ["blur"],
          },
        ],
      },
      roleForm: {
        role: [],
      },
      roleRules: {},
      permissionList: [],
      props: {
        label: "permissionName",
        children: "sonPermissionList",
      },
      keys: [],
      k: [],
    };
  },
  methods: {
    checkKeys(rule, value, callback) {
      const ids = this.filterSon(this.permissionList);
      if (!this.filterSon(this.permissionList)) {
        return callback(new Error("请选择权限"));
      } else {
        callback();
      }
    },
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        name: this.searchName,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.setUp.getRoleList(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    async getPermission(params = null) {
      try {
        const res = await this.$api.setUp.getPermission(params ? params : "");
        if (res.code === 10200) {
          this.permissionList = [];
          this.keys = [];
          this.form.roleName = res.data.roleName;
          this.permissionList = res.data.rolePermissionList;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {}
    },
    async add() {
      await this.getPermission();
      this.add_role_dialog = true;
    },
    check(data, val) {
      data.value = val;
      if (data.sonPermissionList) this.recursion(data.sonPermissionList, val);
      const ids = this.findParents(this.permissionList, data.permissionId, val);
      ids.forEach((item) => {
        if (item.sonPermissionList) {
          if (this.filterSon(item.sonPermissionList)) item.value = 1;
          else item.value = 0;
        }
      });
    },
    findParents(treeData, id, status) {
      let allparents = [];
      let findele = (data, id) => {
        data.forEach((item) => {
          if (item.permissionId == id) {
            if (status) allparents.unshift(item);
            else allparents.push(item);
            findele(treeData, item.parentId);
          } else {
            if (item.sonPermissionList) {
              findele(item.sonPermissionList, id);
            }
          }
        });
      };
      findele(treeData, id);
      return allparents;
    },
    filterSon(arr) {
      let val = [];
      let recursion = (arr) => {
        arr.forEach((item) => {
          if (item.value) val.push(item.permissionId);
          if (item.sonPermissionList) {
            recursion(item.sonPermissionList);
          }
        });
      };
      recursion(arr);
      return val.length > 0 ? 1 : 0;
    },
    recursion(arr, val) {
      arr.forEach((item) => {
        item.value = val;
        if (item.sonPermissionList) {
          this.recursion(item.sonPermissionList, val);
        }
      });
    },
    close() {
      this.form = {
        roleName: "",
        keys: [],
      };
      this.itemData = {};
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.itemData.id) {
            this.setRole();
          } else {
            this.addRole();
          }
        } else {
          return false;
        }
      });
    },
    async addRole() {
      if (!this.loading) {
        try {
          const params = {
            roleName: this.form.roleName,
            permissionList: this.permissionList,
          };
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.setUp.addRole(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.add_role_dialog = false;
            this.$message.success("添加成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    async edit(data) {
      this.itemData = data;
      await this.getPermission({ roleId: data.id });
      this.add_role_dialog = true;
    },

    async setRole() {
      if (!this.loading) {
        try {
          const params = {
            roleId: this.itemData.id,
            roleName: this.form.roleName,
            permissionList: this.permissionList,
          };
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.setUp.setRole(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData(this.data.current);
            this.$message.success("设置成功！");
            this.add_role_dialog = false;
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    delData(data) {
      if (!this.loading) {
        this.$confirm("是否确认删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const res = await this.$api.setUp.delRole(data.id);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                this.$message.success("删除成功");
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
  },
  created() {
    this.getData();
  },
  watch:{
    searchName:{
      handler(){
        this.getData()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.el-image {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.administrator {
  padding: 0 20px;
  .administrator_wrap {
    display: flex;
    border: 1px solid $--border-color-base;

    & > div {
      flex: 1;
      min-height: 300px;

      &:first-child {
        border-right: 1px solid $--border-color-base;
      }

      h2 {
        height: 40px;
        line-height: 40px;
        font-size: 1rem;
        font-weight: 500;
        text-align: center;
        box-sizing: border-box;
        border-bottom: 1px solid $--border-color-base;
      }

      ul {
        padding: 0 40px;

        li {
          display: flex;
          height: 40px;
          align-items: center;

          & > span {
            margin-left: auto;
            i {
              cursor: pointer;
              font-size: 1.25rem;
              color: $--color-primary;
            }
          }
        }
      }
    }
  }

  .el-select,
  .el-input {
    width: 240px;
  }
}

.permission_name {
  width: 100%;
  cursor: pointer;
  line-height: 23px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.role-permission {
  line-height: 30px;
}

.el-scrollbar .el-scrollbar__wrap {
  max-height: 400px;
}
</style>